
<app-form-input
[parentForm]="parentForm"
[value]="annulation"
[disabled]="disabled"
[label]="step3.getinfosannulation"
[type]="'text'" [rule]="'required|minSize_5'"
[errorMessage]="{'required' : 'ctr_330'}"
[name]="getUid()+'_SepAtt_infosAnnulation'">
</app-form-input>

